import { useAuth } from '../store/authStore';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

function Login() {
  const { login, isAuthenticated, isLoading, error } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className="login">
      <h1>Admin Console</h1>
      <p>Sign in with your Ludic Drive Assetstore account to manage the store.</p>
      {error && <p className="error-message">{error}</p>}
      <button
        type="button"
        className="btn btn--primary btn--lg"
        onClick={login}
        disabled={isLoading}
      >
        {isLoading ? 'Redirecting…' : 'Sign in'}
      </button>
    </div>
  );
}

export default Login;
